addEventListener("DOMContentLoaded", () => {

    if (document.getElementsByClassName('add-cart-redirect-variants')) {
        [...document.getElementsByClassName("add-cart-redirect-variants")].forEach((container) => {

            let data = [];
            [...container.children].forEach(item => {
                data.push({
                    url: item.href,
                    title: item.title,
                    active: item.dataset.active === "true" || item.dataset.active === "1",
                    image: item.children[0].src
                });
                container.removeChild(item);
            });

            if (data.length === 0) return;

            // wrapper variant
            let variantWrapper = document.createElement("div");
            variantWrapper.className = "variant";
            container.appendChild(variantWrapper);

            let nav = document.createElement("nav");
            variantWrapper.appendChild(nav);

            let variants = [];
            let index = 0;

            // šipky
            let arrR = document.createElement("div");
            arrR.innerHTML = `<span class="arrow-right"></span>`;
            let arrL = document.createElement("div");
            arrL.innerHTML = `<span class="arrow-left"></span>`;

            // funkce na výpočet max podle šířky
            function getMax(width) {
                if (width <= 375) return 3;
                if (width <= 426) return 4;
                if (width <= 768) return 6;
                if (width <= 1024) return 5;
                return 6;
            }

            let max = getMax(window.innerWidth);
            let shift = Math.min(max, data.length);

            // najdi aktivní index
            let activeIndex = data.findIndex(item => item.active);
            if (activeIndex !== -1) {
                index = activeIndex - Math.floor(shift / 2);
                if (index < 0) index = 0;
                if (index > data.length - shift) index = data.length - shift;
            }

            // funkce fill (překreslení)
            let fill = (dir) => {
                index += dir;
                if (index < 0) index = 0;
                if (index > data.length - shift) index = data.length - shift;

                let originalName = null;
                let variantNameEl = document.getElementById("variant-name");

                for (let i = 0; i < shift; i++) {
                    let item = data[index + i];
                    if (!item) continue;

                    let div = variants[i];
                    let a = div.querySelector("a");
                    let img = div.querySelector("img");

                    a.href = item.url;
                    a.title = item.title;
                    img.src = item.image;

                    div.classList.toggle("active", item.active);

                    div.onmouseenter = () => {
                        if (!variantNameEl) return;
                        if (originalName === null) originalName = variantNameEl.innerText;
                        variantNameEl.innerText = item.title;
                    };
                    div.onmouseleave = () => {
                        if (!variantNameEl) return;
                        if (originalName !== null) variantNameEl.innerText = originalName;
                    };
                }

                updateArrows();
            };

            // funkce update šipek
            let updateArrows = () => {
                arrL.style.display = index > 0 ? "flex" : "none";
                arrR.style.display = (index + shift) < data.length ? "flex" : "none";
            };

            // funkce na rebuild variant při resize
            function rebuild() {
                const newMax = getMax(window.innerWidth);
                if (newMax === max) return; // nic se nezměnilo

                max = newMax;
                shift = Math.min(max, data.length);

                // smaž staré prvky
                nav.innerHTML = "";
                variants = [];

                // vytvoř nové prvky
                for (let i = 0; i < shift; i++) {
                    let div = document.createElement("div");
                    let a = document.createElement("a");
                    let img = document.createElement("img");
                    a.appendChild(img);
                    div.appendChild(a);
                    variants.push(div);
                    nav.appendChild(div);
                }

                // přidej šipky
                variants[variants.length - 1].appendChild(arrR);
                variants[0].appendChild(arrL);

                // uprav index
                if (index > data.length - shift) index = data.length - shift;
                if (index < 0) index = 0;

                fill(0);
            }

            // debounce resize
            let resizeTimeout;
            window.addEventListener("resize", () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(rebuild, 150);
            });

            // vytvoř prvky poprvé
            for (let i = 0; i < shift; i++) {
                let div = document.createElement("div");
                let a = document.createElement("a");
                let img = document.createElement("img");
                a.appendChild(img);
                div.appendChild(a);
                variants.push(div);
                nav.appendChild(div);
            }

            // přidej šipky
            variants[variants.length - 1].appendChild(arrR);
            variants[0].appendChild(arrL);

            // onclick šipky
            arrR.onclick = (e) => { fill(Math.floor(shift/2)); e.stopPropagation(); };
            arrL.onclick = (e) => { fill(-Math.floor(shift/2)); e.stopPropagation(); };

            // inicializace
            fill(0);
        });

    }


    // === Select box ===
    const select = document.getElementById('sizeSelect');
    if (select) {
        const
            selected = select.querySelector('.select__selected span:first-child'),
            options = select.querySelectorAll('.select__option'),
            inputSize = document.getElementById('sizeInput'),
            inputColor = document.getElementById('colorInput'),
            inputProductId = document.getElementById('productIdInput');

        // otevření
        select.querySelector('.select__selected').addEventListener('click', () => {
            select.classList.toggle('open');
        });

        // výběr
        options.forEach(option => {
            option.addEventListener('click', () => {
                if (option.classList.contains('disabled')) {
                    return;

                }

                const value = option.dataset.value;

                selected.innerText = option.querySelector('.title').innerText;
                select.querySelector('.select__selected').classList.remove('placeholder');
                inputSize.value = value;

                document.getElementById('size-input-message').classList.add('hidden');

                // přidání třídy pro rámeček
                select.classList.add('has-value');

                // zvýraznění vybrané varianty
                options.forEach(opt => opt.classList.remove('selected'));
                option.classList.add('selected');

                naja.makeRequest(
                    'POST',
                    select.dataset.link,
                    {
                        'size': inputSize.value,
                        'color': inputColor.value,
                        'productId': inputProductId.value,
                    }

                ).then(response => {})

                select.classList.remove('open');
            });
        });

        // klik mimo
        document.addEventListener('click', (e) => {
            if (!select.contains(e.target)) select.classList.remove('open');
        });
    }

    if (document.getElementById('add-to-cart')) {
        document.getElementById('add-to-cart').addEventListener('click', (e) => {
            const input = document.getElementById('sizeInput');

            if (input && !input.value) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                document.getElementById('size-input-message').classList.remove('hidden');
                return false;
            }
        }, true);
    }


});